import React from 'react';
import TopicTreeBrowser from './TopicTreeBrowser';

const TopicTreeSwitch = function () {
  return (
    <div className="topic-tree-switcher">
      <TopicTreeBrowser />
    </div>
  );
};

export default TopicTreeSwitch;
